module.exports = __webpack_public_path__ + "img/panel-login.555c7234.png";